import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import type { INavContainer } from '../../models';

import styles from './style.css';
import { ArrowLeft } from './arrow-left';
import { ArrowRight } from './arrow-right';

export const NavContainer: FC<INavContainer> = ({
    canGoLeft,
    canGoRight,
    children,
    dataTestId = 'Carousel',
    onLeft,
    onRight,
}) => {
    return (
        <div className={styles.navContainer}>
            <ArrowLeft
                className={cn(styles.left, styles.external)}
                dataTestId={`${dataTestId}-NavButton-Left`}
                onClick={onLeft}
                visible={canGoLeft}
            />
            {canGoLeft && (
                <div className={styles.leftShadowBlock}>
                    <div className={cn(styles.shadow, styles.leftShadow)} />
                </div>
            )}
            {children}
            <ArrowRight
                className={cn(styles.right, styles.external)}
                dataTestId={`${dataTestId}-NavButton-Right`}
                onClick={onRight}
                visible={canGoRight}
            />
            {canGoRight && (
                <div className={styles.rightShadowBlock}>
                    <div className={cn(styles.shadow, styles.rightShadow)} />
                </div>
            )}
        </div>
    );
};
